export const toDollars = (value: number | string) => (+value / 100).toFixed(2);
